import { render, staticRenderFns } from "./EmailChange.vue?vue&type=template&id=f2d4d1f0&"
import script from "./EmailChange.vue?vue&type=script&lang=js&"
export * from "./EmailChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports